import { Dialog } from "../../../../features/Dialog";
import { DialogsPage } from "../../../../pages/DialogsPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const dialogsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.dialogs.root,
  element: <DialogsPage />,
  name: "Диалоги",
  children: appRouterPaths.dialogs.item
    ? [
        {
          path: appRouterPaths.dialogs.item,
          element: <Dialog />,
          name: "Диалог",
        },
      ]
    : undefined,
};
